import { useState } from 'react';

//interfaces
import { ListLayoutTypes, ListLayoutKey, ListLayoutValue } from '@/interfaces/listLayout';

//helpers and hooks
import { getSelectedTypeKey } from '@/helpers/ListLayouts';


const UseListLayout = (defaultSelectedType: string) => {
    const [selectedLayout, setSelectedLayout] = useState<ListLayoutKey>(getSelectedTypeKey(defaultSelectedType));
    const layoutTypes = 
        Object.entries(ListLayoutTypes) as 
        [keyof typeof ListLayoutTypes, ListLayoutValue][];

    return {
        setSelectedLayout,
        selectedLayout,
        layoutTypes
    }
}

export default UseListLayout